import ProjectAPIError from "@/api/error/ProjectAPIError";

export default class ProjectAPIForbiddenError extends ProjectAPIError {
  get httpErrorMessage() {
    return "금지된 요청입니다";
  }
}
